module.exports = __webpack_public_path__ + "static/media/homologacion.a3e70a67.png";